const {jQuery: $} = window;
import Utils from "./utils.class";
import Cookies from 'js-cookie';
// import Cookiebot from "./CMP/Cookiebot.class";
import PieChartCounter from "./components/PieChartCounter.class";
import ElementorInPageNavWidget from "./components/ElementorInPageNav.class";

export default class Theme {
    $main;
    $html;
    $body;
    $header;
    #config;
    #scrollOffset;
    #scrollSpeed;
    #slider;
    #tabbedNav;
    #$admin;
    #root;
    // #cmp;
    #counter;
    constructor(
        config,
        slider,
        tabbedNav
    ) {
        this.#config = config;
        this.#scrollOffset = 0;
        this.#root = document.querySelector(":root");

        this.#scrollSpeed = 750;
        this.$html = $('html');

        this.$body = $('body');
        this.$main = $('#site-wrapper');
        this.$header = $('header.elementor-location-header');
        this.#$admin = $('#wpadminbar');
        this.#slider = slider;
        this.#tabbedNav = tabbedNav;
        this.#counter = $('.counter__number');

        if (window.location.hash === "#dev") {
            Cookies.set("debug", "1");
        }

        Utils.log("Theme Config:", config);

        // this.#cmp = new Cookiebot(this.$body);

        new PieChartCounter(this);
        new ElementorInPageNavWidget(".inPageNav--active > nav", this.headerHeight);
    }

    __onReady() {
        const me = this;
        Utils.log("Theme Ready");
        this.#updateCssHeaderHeight();

        this.#tabbedNav.events();
        // Utils.equalHeight('.kpfsc__post', '.kpf-slider-mode form > .kpfsc__posts');

        // equalHeight kpfsc__post kpfsc__posts.slick-slider

        $(window).on('hashchange', function (e) {
            Utils.log("Scroll to Section Ready");

            if (location.hash) {
                if (!Utils.scrollToHash(location.hash, null, me.scrollOffset, me.#scrollSpeed)) {
                    e.preventDefault();
                }
            }
        });

        $(document).on('click', 'a', function (e) {
            let $el = $(this);

            if ($el.attr('href') && $el.attr('href').search('#') === 0) {
                let hash = $el[0].hash;

                // if (hash === "#open-cmp") {
                //     me.CMP.open();
                //     e.preventDefault();
                //     return false;
                // }

                if (!Utils.scrollToHash(hash, null, me.scrollOffset, me.#scrollSpeed)) {
                    e.preventDefault();
                }
            }
        });

        $('a').each(function (i, el) {
            const url = $(el).attr("href");
            // use url.indexOf() to look for youtube embed urls
            // apply featherlight on those tags
            if (url) {
                if (url.indexOf("youtube.com/watch?v=") >= 0 || url.indexOf("youtu.be/") >= 0 || (url.indexOf("youtube.com/embed/") >= 0)) {
                    const id = Utils.youtubeParser(url);
                    $(el).attr("data-featherlight", "iframe")
                        .attr("data-featherlight-iframe-width", "850")
                        .attr("data-featherlight-iframe-height", "468")
                        .attr("data-featherlight-iframe-frameborder", "0")
                        .attr("data-featherlight-iframe-allow", "autoplay; encrypted-media")
                        .attr("data-featherlight-iframe-allowfullscreen", "true")
                        .attr("href", "https://www.youtube.com/embed/" + id + "?rel=0&amp;autoplay=1");

                    $(el).featherlight();
                }
            }
        });

        $(".rotator-text-sc").each(function (i, el) {
            const $el = $(el);
            const items = $el.data("items").split(",");
            const section = $el.parents(".elementor-element[data-element_type='container']").last();
            let first = true;

            const runner = (index = 0) => {
                if(index >= items.length) index = 0;
                const item = items[index].split("|");
                const text = item[0];
                const speed = item[1] || 5000;

                if(!first) {
                    $el.animate({opacity: 0}, 100, () => {
                        $(section).trigger('rotator_change', [$el, index, speed]);
                        $el.html(text).animate({opacity: 1}, 100);
                    });
                } else {
                    $(section).trigger('rotator_change', [$el, index, speed]);
                    $el.html(text);
                    first = false;
                }

                setTimeout(() => runner(index + 1), speed);
            };

            runner();
        });

        $(".kpf-slider-mode").each(function (i, el) {
            const $el = $(el);
            const $arrowToggle = $el.data("arrows");
            const $dotToggle = $el.data("dots");
            const $speed = $el.data("speed");
            const $mobileSpeed = $el.data("mobile-speed");
            const $cycle = $el.data("cycle");
            const $tiles = $el.data("tiles");
            const $tilescroll = $el.data("tilescroll");
            const $rightArrow = '<i class="fa fas fa-chevron-right" />';
            const $leftArrow = '<i class="fa fas fa-chevron-left" />';
            // $el.css({'visibility': 'visible'});
            let $responsiveTiles;
            switch ($tiles) {
                case 3:
                    $responsiveTiles = 2;
                    break;
                case 2:
                    $responsiveTiles = 2;
                    break;
                case 1:
                    $responsiveTiles = 1;
                    break;
                default:
                    $responsiveTiles = 2;
                    break;
            }

            $el.find(".kpfsc__posts").slick({
                arrows: $arrowToggle,
                prevArrow: `<button type="button" class="slick-prev slick-custom-prev"> ${$leftArrow} </button>`,
                nextArrow: `<button type="button" class="slick-next slick-custom-next"> ${$rightArrow} </button>`,
                autoplay: $cycle,
                autoplaySpeed: $speed,
                pauseOnFocus: true,
                pauseOnHover: true,
                autoHeight: "calc",
                dots: $dotToggle,
                adaptiveHeight: false,
                infinite: true,
                slidesToScroll: $tilescroll,
                slidesToShow: $tiles,
                swipeToSlide: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: $responsiveTiles,
                        }
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 1,
                            autoplaySpeed: $mobileSpeed,
                        }
                    }
                ]
            });
        });

        $(".rcioFilterBar__filter select[name='resource-location']").on('change', function () {
            window.location.href = $(this).val();
        });

        this.#setupSearch();
    }

    __onLoad() {
        const me = this;

        Utils.log("Theme Load");

        this.#updateCssHeaderHeight();

        this.$header.addClass('fixed');


        const top = 1; // Trigger on any scrolling

        $(document).scroll(function () {
            
            const scrollPos = $(document).scrollTop();
            if (top && scrollPos >= top) {
                $('.elementor-location-header').addClass('scrolled');
            } else if (top && scrollPos < top) {
                $('.elementor-location-header').removeClass('scrolled');
            }
        });


        $(window).trigger("resize");

        $('.search-bar .search-button').on('click', function () {
            $(this).parent().toggleClass('open');
        });


        if ($("#menu-wrapper").length > 0) {
            const menu = new window.Mmenu("#menu-wrapper", {
                theme: 'white',
                offCanvas: {
                    "position": "right-front",
                },
            }, {
                offCanvas: {
                    "page": {
                        "selector": "#site-wrapper"
                    }
                }
            });

            const api = menu.API;
            const $toggle = $(".mmenu-toggle");

            $toggle.on("click", function () {
                api.open();
            });

            api.bind("open:after", function () {
                $toggle.attr("aria-expanded", "true");
            });

            api.bind("close:after", function () {
                $toggle.attr("aria-expanded", "false");
                $toggle.trigger("focus");
            });
        }

        //Preserve UTM codes across site browsing
        let utmParams = {};
        const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
        let utmString = '';
        utmKeys.forEach(key => {
            if (Utils.URLSearchParams.has(key)) {
                utmParams[key] = encodeURIComponent(Utils.URLSearchParams.get(key) || "");
                utmString += `&${key}=${utmParams[key]}`;
            }
        });

        if (Object.keys(utmParams).length > 0) {
            $("a").each(function (e) {
                let $el = $(this);
                if (location.host === $el[0].host && $el[0].hash === '') {
                    if ($el[0].search) {
                        $el.attr("href", `${$el.attr('href')}${utmString}`);
                    } else {
                        $el.attr("href", `${$el.attr('href')}${utmString.replace('&', '?')}`);
                    }
                }
            });
        }

        // Fix SVG's with embedded clip-paths
        $("svg").each(function (i, el) {
            const $el = $(el);
            const $me = $el;

            const $parent = $el.closest(".elementor-widget");
            let pathIDs = [];
            const suffix = $parent.data("id");
            const instance = i;

            $el.find("clipPath").each((i, el) => {
                const $cp = $(el);
                let id = $cp.attr("id");
                pathIDs.push(id);
                $cp.attr("id", `${id}-${suffix}-${instance}`);
            });

            $el.find("linearGradient").each((i, el) => {
                const $cp = $(el);
                let id = $cp.attr("id");
                pathIDs.push(id);
                $cp.attr("id", `${id}-${suffix}-${instance}`);
                $cp.attr("xlink:href", $cp.attr("xlink:href") + `-${suffix}-${instance}`);

                $me.find("style").each((i, el) => {
                    const $style = $(el);
                    $style.text($style.text().replaceAll(`url(#${id})`, `url(#${id}-${suffix}-${instance})`));
                });
            });

            $el.find("[class*='cls-']").each((i, el) => {
                // DOMTokenList.replace() swaps a whole token, so rename each cls-* class in turn

                [...el.classList]
                    .filter(cls => cls.startsWith("cls-"))
                    .forEach(cls => el.classList.replace(cls, `cls-${suffix}-${instance}-${cls.slice(4)}`))
            });

            $el.find("style").each((i, el) => {
                const $style = $(el);
                $style.text($style.text().replaceAll(`cls-`, `cls-${suffix}-${instance}-`));
            });

            pathIDs.forEach((val, key) => {
                $el.find(`[clip-path="url(#${val})"]`).each((i, el) => {
                    const $cpEL = $(el);
                    $cpEL.attr("clip-path", `url(#${val}-${suffix}-${instance})`);
                });

                $el.find(`[fill="url(#${val})"]`).each((i, el) => {
                    const $cpEL = $(el);
                    $cpEL.attr("fill", `url(#${val}-${suffix}-${instance})`);
                });

                $el.find("style").each((i, el) => {
                    const $style = $(el);
                    $style.text($style.text().replaceAll(`url(#${val})`, `url(#${val}-${suffix}-${instance})`));
                });
            });
        });

        $('.js--hide-while-loading').removeClass('js--hide-while-loading');
    }

    __onResize() {
        this.#updateCssHeaderHeight();
    }

    /**
     * @param {PostFilters} kpf
     * @public
     */
    __postFilters(kpf) {
        Utils.log("Theme customizations for Post Filters...");
        kpf.addFilter('post_transition_delay', () => 0)

        $(".kpfsc__filterButtons").on("click", function () {
            $("#archiveSelect").val(null);
            const dataValue = $(this).data("value");

            if (dataValue.split) {
                $("#archiveSelect").val(dataValue.split(",")).trigger('change');
            } else {
                $("#archiveSelect").val(dataValue).trigger('change');
            }
        });

    }

    activatePlayer() {
        // TODO: Implement video platform integration
    }

    get utils() {
        return Utils;
    }

    get headerHeight() {
        return this.$header.outerHeight();
    }

    get scrollOffset() {
        let subNav = 0;

        return this.#scrollOffset + this.headerHeight + subNav;
    }

    #setupSearch() {
        function toggleClassForEls(els, theClass) {
            els.forEach((item) => {
                item.classList.toggle(theClass);
            });
        }

        const searchIcon = document.querySelectorAll('.search-menu-icon');
        const searchIconClose = document.querySelectorAll('.search-menu-icon-close');
        const searchBox = document.querySelector('#search-menu-box');

        searchIcon.forEach((item) => {
            item.addEventListener('click', () => {
                const mobileToggle = document.querySelector('.mobile-menu .elementor-menu-toggle')

                if (mobileToggle && mobileToggle.classList.contains('elementor-active')) {
                    document.querySelector('.mobile-menu .elementor-menu-toggle').click();
                }

                searchBox.classList.toggle('isvisible');
                toggleClassForEls(searchIcon, 'isvisible');
                toggleClassForEls(searchIconClose, 'isvisible');
                document.querySelector('.elementor-search-form__input').focus();
            })
        });

        searchIconClose.forEach((item) => {
            item.addEventListener('click', () => {
                searchBox.classList.toggle('isvisible');
                toggleClassForEls(searchIcon, 'isvisible');
                toggleClassForEls(searchIconClose, 'isvisible');
                document.querySelector('.elementor-search-form__input').blur();
            })
        });
    }

    // get CMP() {
    //     return this.#cmp;
    // }

    get UTMs() {
        return {
            id: encodeURIComponent(Utils.URLSearchParams.get('utm_id') || ""),
            campaign: encodeURIComponent(Utils.URLSearchParams.get('utm_campaign') || ""),
            source: encodeURIComponent(Utils.URLSearchParams.get('utm_source') || ""),
            medium: encodeURIComponent(Utils.URLSearchParams.get('utm_medium') || ""),
            term: encodeURIComponent(Utils.URLSearchParams.get('utm_term') || ""),
            content: encodeURIComponent(Utils.URLSearchParams.get('utm_content') || ""),
            GCLID: encodeURIComponent(Cookies.get("gclid") || "")
        };
    }

    #updateCssHeaderHeight() {
        if(this.$header.length > 0) {
            this.#root.style.setProperty('--theme--header-height', this.headerHeight + "px");
            this.#root.style.setProperty('--theme--header-top', (this.$header.position().top + 20) + "px");
        }
    }
}